var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.766,
    height: 15.75,
    viewBox: "0 0 15.766 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M6.625-7H.375a.362.362,0,0,1-.266-.109A.362.362,0,0,1,0-7.375v-6.25A.331.331,0,0,1,.375-14h1.5a.331.331,0,0,1,.375.375v2.438a7.606,7.606,0,0,1,2.609-1.891,7.816,7.816,0,0,1,3.2-.672,7.528,7.528,0,0,1,5.469,2.3,7.423,7.423,0,0,1,2.234,5.469A7.507,7.507,0,0,1,13.484-.516,7.47,7.47,0,0,1,8,1.75a7.5,7.5,0,0,1-5.187-2,.342.342,0,0,1-.031-.562L3.844-1.875a.345.345,0,0,1,.531,0A5.32,5.32,0,0,0,8-.5a5.3,5.3,0,0,0,3.891-1.609A5.3,5.3,0,0,0,13.5-6a5.3,5.3,0,0,0-1.609-3.891A5.3,5.3,0,0,0,8-11.5a5.281,5.281,0,0,0-2.5.609A5.782,5.782,0,0,0,3.563-9.25H6.625a.362.362,0,0,1,.266.109A.362.362,0,0,1,7-8.875v1.5a.362.362,0,0,1-.109.266A.362.362,0,0,1,6.625-7Z",
    transform: "translate(0 14)",
    fill: "#2a66bf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.d0b058ebb8f181384bc444cd474ead66.svg";
export { ForwardRef as ReactComponent };